import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { chatService } from './chatApi';

export function useChat() {
  console.log('🚀🚀🚀 useChat FUNÇÃO EXECUTADA! 🚀🚀🚀');
  
  const store = useStore();
  
  // Estado reativo do chat
  const availableUsers = ref([]);
  const activeConversations = ref([]);
  const currentChat = ref(null);
  const currentMessages = ref([]);
  const isLoading = ref(false);
  const error = ref(null);
  const userProfile = ref(null);
  
  // Polling para atualizações
  let pollInterval = null;
  
  // Computed properties
  const currentUserType = computed(() => store.state.user.loggedAs);
  const currentUserId = computed(() => {
    switch (store.state.user.loggedAs) {
      case 'professional':
        return store.state.professional?.professional_id;
      case 'recruiter':
        return store.state.recruiter?.recruiter_id;
      case 'company':
        return store.state.company?.company_id;
      default:
        return null;
    }
  });
  
  const currentUserName = computed(() => store.getters.getNameByProfile);
  const currentUserPhoto = computed(() => store.getters.getProfileImage);
  
  // Função simplificada para testar
  const loadUserProfile = async () => {
    console.log('🔄 TESTE: loadUserProfile chamado!');
    try {
      isLoading.value = true;
      error.value = null;
      
      console.log('🔍 Chamando chatService.getUserProfile()...');
      const response = await chatService.getUserProfile();
      console.log('✅ Resposta recebida:', response);
      
      userProfile.value = response;
      return response;
    } catch (err) {
      console.error('❌ Erro em loadUserProfile:', err);
      error.value = `Erro: ${err.message}`;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };
  
  const loadAvailableUsers = async () => {
    console.log('🔄 Carregando usuários disponíveis...');
    try {
      isLoading.value = true;
      error.value = null;
      
      // Carregar usuários baseado no tipo do usuário
      const userType = currentUserType.value;
      console.log('👤 Tipo do usuário atual:', userType);
      
      if (userType) {
        // Usar a nova função getAvailableUsers
        console.log('🔍 Carregando usuários para tipo:', userType);
        const response = await chatService.getAvailableUsers(userType);
        availableUsers.value = response.data?.data || [];
        console.log('✅ Usuários carregados:', availableUsers.value);
      } else {
        console.log('⚠️ Tipo de usuário não definido, pulando usuários');
        availableUsers.value = [];
      }
      
      console.log('📊 Total de usuários disponíveis:', availableUsers.value.length);
      
    } catch (err) {
      console.error('❌ Erro ao carregar usuários:', err);
      error.value = `Erro ao carregar usuários: ${err.message}`;
      availableUsers.value = [];
    } finally {
      isLoading.value = false;
    }
  };

  const loadActiveConversations = async () => {
    console.log('🔄 Carregando conversas ativas...');
    try {
      isLoading.value = true;
      error.value = null;
      
      const userType = currentUserType.value;
      console.log('👤 Carregando conversas para tipo:', userType);
      
      if (userType) {
        const response = await chatService.getConversations(userType);
        activeConversations.value = response.data?.data || [];
        console.log('✅ Conversas carregadas:', activeConversations.value);
      } else {
        console.log('⚠️ Tipo de usuário não definido, pulando conversas');
        activeConversations.value = [];
      }
      
    } catch (err) {
      console.error('❌ Erro ao carregar conversas:', err);
      error.value = `Erro ao carregar conversas: ${err.message}`;
      activeConversations.value = [];
    } finally {
      isLoading.value = false;
    }
  };
  
  const startChat = (userId, userType) => {
    console.log('🔄 Iniciando chat com:', { userId, userType });
    // TODO: Implementar lógica de chat
  };
  
  const sendMessage = async (messageData) => {
    console.log('🔄 Enviando mensagem:', messageData);
    try {
      const response = await chatService.sendMessage(messageData);
      console.log('✅ Mensagem enviada:', response);
      return response;
    } catch (error) {
      console.error('❌ Erro ao enviar mensagem:', error);
      throw error;
    }
  };
  
  const closeChat = () => {
    console.log('🔄 Fechando chat...');
    currentChat.value = null;
    currentMessages.value = [];
  };
  
  const markMessagesAsRead = async (profileType, conversationId) => {
    console.log('🔄 Marcando mensagens como lidas:', { profileType, conversationId });
    try {
      const response = await chatService.markAsRead(profileType, conversationId);
      console.log('✅ Mensagens marcadas como lidas:', response);
      return response;
    } catch (error) {
      console.error('❌ Erro ao marcar como lido:', error);
      throw error;
    }
  };
  
  const startPolling = () => {
    console.log('🔄 Iniciando polling...');
    // TODO: Implementar polling para novas mensagens
  };
  
  const stopPolling = () => {
    console.log('🔄 Parando polling...');
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
  };
  
  // TESTE DIRETO: Executar imediatamente
  console.log('🧪🧪🧪 TESTE DIRETO: Executando loadUserProfile imediatamente... 🧪🧪🧪');
  loadUserProfile().then(response => {
    console.log('🎉🎉🎉 loadUserProfile executado com sucesso! 🎉🎉🎉', response);
  }).catch(err => {
    console.error('💥💥💥 loadUserProfile falhou! 💥💥💥', err);
  });
  
  // Lifecycle SIMPLIFICADO
  onMounted(() => {
    console.log('🚀🚀🚀 useChat onMounted EXECUTADO! 🚀🚀🚀');
    console.log('📍 Arquivo: useChat.js');
    
    // Teste simples
    setTimeout(() => {
      console.log('🔄🔄🔄 TESTANDO loadUserProfile... 🔄🔄🔄');
      loadUserProfile();
    }, 1000);
  });
  
  onUnmounted(() => {
    console.log('🛑 useChat onUnmounted executado');
    stopPolling();
  });
  
  console.log('🚀🚀🚀 useChat RETORNANDO OBJETO! 🚀🚀🚀');
  
  return {
    // Estado
    availableUsers,
    activeConversations,
    currentChat,
    currentMessages,
    isLoading,
    error,
    userProfile,
    
    // Computed
    currentUserType,
    currentUserId,
    currentUserName,
    currentUserPhoto,
    
    // Funções
    loadUserProfile,
    loadAvailableUsers,
    loadActiveConversations,
    startChat,
    sendMessage,
    closeChat,
    markMessagesAsRead,
    startPolling,
    stopPolling
  };
}
